(function () {
  'use strict';
  var reduced = matchMedia('(prefers-reduced-motion: reduce)');
  // Normalized positions in the bundled cut image: skin, paste, fruit.
  var targets = [[0.38, 0.15], [0.25, 0.39], [0.50, 0.64]];
  function clamp(n) { return Math.min(1, Math.max(0, n)); }
  function ease(n, a, b) { var t = clamp((n - a) / (b - a)); return t * t * (3 - 2 * t); }
  function init(root) {
    if (root.dataset.afHeroInit) return;
    root.dataset.afHeroInit = 'true';
    var stage = root.querySelector('[data-af-stage]');
    var cut = root.querySelector('[data-af-cut]');
    var whole = root.querySelector('[data-af-whole]');
    var labels = Array.from(root.querySelectorAll('[data-af-ing]'));
    var bar = root.querySelector('[data-af-progress]');
    var invite = root.querySelector('[data-af-invite]');
    var pending = 0;
    function motion() { return !reduced.matches; }
    function positionLabels() {
      var s = stage.getBoundingClientRect();
      var r = cut.getBoundingClientRect();
      // Account for contain letterboxing if an alternate image isn't square.
      var ratio = cut.naturalWidth / cut.naturalHeight || 1;
      var w = Math.min(r.width, r.height * ratio), h = w / ratio;
      var left = r.left + (r.width - w) / 2, top = r.top + (r.height - h) / 2;
      labels.forEach(function (label) {
        var point = targets[Number(label.dataset.afIng) - 1];
        if (!point) return;
        var x = left + point[0] * w, y = top + point[1] * h;
        label.style.top = (y - s.top) + 'px';
        label.style.setProperty('--af-leader-width', Math.max(0, x - label.getBoundingClientRect().right - 8) + 'px');
      });
    }
    function draw() {
      pending = 0;
      var travel = root.offsetHeight - stage.offsetHeight;
      var p = motion() && travel > 0 ? clamp((parseFloat(root.style.getPropertyValue('--af-sticky-top')) - root.getBoundingClientRect().top) / travel) : 1;
      var reveal = ease(p, 0.08, 0.60);
      whole.style.opacity = 1 - reveal;
      cut.style.opacity = reveal;
      cut.style.clipPath = reveal === 1 ? 'none' : 'circle(' + reveal * 75 + '% at 50% 52%)';
      labels.forEach(function (label, i) { label.style.opacity = motion() ? ease(p, 0.58 + i * 0.05, 0.72 + i * 0.05) : 1; });
      if (bar) bar.style.transform = 'scaleX(' + p + ')';
      if (invite) invite.style.visibility = p > 0.35 ? 'hidden' : 'visible';
    }
    function queue() { if (!pending) pending = requestAnimationFrame(draw); }
    function measure() {
      var header = document.querySelector('.header, header.header, #shopify-section-header');
      var pos = header && getComputedStyle(header).position;
      root.style.setProperty('--af-sticky-top', ((pos === 'sticky' || pos === 'fixed') ? header.getBoundingClientRect().height : 0) + 'px');
      root.classList.toggle('af-hero--motion', motion());
      positionLabels();
      draw();
    }
    var observer = new ResizeObserver(measure);
    observer.observe(stage);
    observer.observe(cut);
    labels.forEach(function (label) { observer.observe(label); });
    addEventListener('scroll', queue, { passive: true });
    addEventListener('resize', measure, { passive: true });
    cut.addEventListener('load', measure);
    reduced.addEventListener('change', measure);
    if (document.fonts) document.fonts.ready.then(measure);
    if (invite) invite.addEventListener('click', function (e) {
      if (!motion()) return;
      e.preventDefault();
      scrollTo({ top: scrollY + root.getBoundingClientRect().top - parseFloat(root.style.getPropertyValue('--af-sticky-top')) + (root.offsetHeight - stage.offsetHeight) * 0.9, behavior: 'smooth' });
    });
    function cleanup(e) {
      if (!e.target.contains(root)) return;
      observer.disconnect();
      cancelAnimationFrame(pending);
      removeEventListener('scroll', queue);
      removeEventListener('resize', measure);
      reduced.removeEventListener('change', measure);
      document.removeEventListener('shopify:section:unload', cleanup);
    }
    document.addEventListener('shopify:section:unload', cleanup);
    measure();
  }
  function initAll() { document.querySelectorAll('[data-af-hero]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
})();
